<template>
    <section></section>
</template>

<script>
    export default {
        name: "emptySection"
    }
</script>

<style scoped>

</style>